import { useCallback } from 'react';
import type { NumberWidgetContainerProps, NumberWidgetOwnProps } from './number.js';

function parseNumberInput(value: string) {
  if (value === '') return undefined;
  if (value.endsWith('.')) return value;
  const number = Number(value);
  if (Number.isNaN(number)) return value;
  return number;
}

export const useNumber = (props: NumberWidgetOwnProps): NumberWidgetContainerProps => {
  const { onChange, onBlur } = props;

  const handleChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> = useCallback(
    (event) => {
      const { value } = event.target;
      onChange(parseNumberInput(value));
      onBlur();
    },
    [onBlur, onChange]
  );

  return { handleChange };
};
